<ng-container *ngIf="technicians && technicians.length > 0">
  <span
    class="status-pill technician inline-block mb-1"
    *ngFor="let technician of technicians; let l = last"
    >{{ technician.personnelCode }}<span class="print-only-inline" *ngIf="!l">,</span>
  </span>
</ng-container>
